import { GroupedShoppingCart, ShoppingCartItem } from "@core-models/shopping-cart-items.model";

export class CartUtil 
{
  public static preProcessCartItems(shoppingCartItems: ShoppingCartItem[]): GroupedShoppingCart[]
  {
    const groupedItems = Object.entries(shoppingCartItems.reduce((accumulator, currentItem) =>
    {
      const currentKey = currentItem.quantityGroup;

      (accumulator[currentKey] = accumulator[currentKey] || []).push(currentItem);

      return accumulator;
    }, {}));

    const result : GroupedShoppingCart[] = groupedItems.map((item: any) => ({ product: item[1][0], quantityGroup: item[0], counter: item[1].length }));
    return result;
  }
}